import React from "react";
import { Carousel, Tabs } from "antd";

const { TabPane } = Tabs;

class WithdrawLesson extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rapidIndex: 0,
            generalIndex: 0,
        };
    }

    componentDidMount() {
        document.addEventListener(
            "keydown",
            function (event) {
                event.stopPropagation();
                console.log(event);
            },
            true
        );
    }

    handleChange = (key) => {
        console.log(key);
    };

    rapidPrevClick = () => {
        this.refs.RapidSlider.slick.slickPrev();
    };

    rapidNextClick = () => {
        console.log("checkpoint", this.refs);
        this.refs.RapidSlider.slick.slickNext();
    };

    generalPrevClick = () => {
        this.refs.GeneralSlider.slick.slickPrev();
    };

    generalNextClick = () => {
        console.log("checkpoint", this.refs);
        this.refs.GeneralSlider.slick.slickNext();
    };

    rapidOnChange = (n) => {
        console.log(n);
        this.setState({ rapidIndex: n });
    };

    generalOnChange = (n) => {
        console.log(n);
        this.setState({ generalIndex: n });
    };

    handleClick = () => {
        console.log("close modal");
        this.props.onhandleCancel();
    };

    render() {
        const defaultTabNum = this.props.tabNum;

        const withdrawCryptoLessons = [
            {
                index: 0,
                id: "withdraw-ls-1",
                content: () => <></>,
            },
            {
                index: 1,
                id: "withdraw-ls-2",
                content: () => <></>,
            },
            {
                index: 2,
                id: "withdraw-ls-3",
                content: () => <></>,
            },
            {
                index: 3,
                id: "withdraw-ls-4",
                content: () => <></>,
            },
        ];

        const withdrawCryptoComment = [
            {
                id: 1,
                title: "步骤1",
                content: "如何提现泰达币",
            },
            {
                id: 2,
                title: "步骤2",
                content: "如何添加钱包地址",
            },
            {
                id: 3,
                title: "步骤3",
                content: "成功添加钱包地址后点击提交即可完成交易",
            },
            {
                id: 4,
                title: "步骤4",
                content: "提交成功",
            },
            {
                id: 5,
                title: "步骤5",
                content: "查看交易记录",
            },
            {
                id: 6,
                title: "",
                content: "",
            },
        ];

        const addressCryptoLessons = [
            {
                index: 0,
                id: "address-ls-1",
                content: () => <></>,
            },
            {
                index: 1,
                id: "address-ls-2",
                content: () => <></>,
            },
        ];

        const addressCryptoComment = [
            {
                id: 1,
                title: "步骤1",
                content: "如何添加钱包地址",
            },
            {
                id: 2,
                title: "步骤2",
                content: "添加钱包地址",
            },
            {
                id: 3,
                title: "步骤3",
                content: "如何在第三方获取您的钱包地址",
            },
            {
                id: 4,
                title: "步骤4",
                content: "复制地址后返回本站提现账户页面",
            },
            {
                id: 5,
                title: "步骤5",
                content: "输入完成点击添加即可",
            },
        ];

        return (
            <React.Fragment>
                <div style={{ textAlign: "center" }}>
                    <Tabs
                        defaultActiveKey="1"
                        onChange={this.handleChange}
                        centered={true}
                    >
                        <TabPane tab="如何提款泰达币?" key="1">
                            <Carousel
                                key={0}
                                ref="RapidSlider"
                                className="custom-Carousel"
                                afterChange={(current) => {
                                    this.rapidOnChange(current);
                                }}
                            >
                                {withdrawCryptoLessons.map((item, index) => (
                                    <div
                                        key={item.id}
                                        className={`crypto-lesson-wrap ${item.id}`}
                                    >
                                        <div className="crypto-lesson-body">
                                            {item.content()}
                                        </div>
                                    </div>
                                ))}
                            </Carousel>
                            {this.state.rapidIndex > 0 && (
                                <div
                                    className="left-next"
                                    onClick={this.rapidPrevClick}
                                >
                                    <img
                                        className="arrowLeftRight"
                                        src={
                                            "/cn/img/withdrawlesson/icon-left.svg"
                                        }
                                        alt="left"
                                    />
                                </div>
                            )}
                            {this.state.rapidIndex !=
                                withdrawCryptoLessons.length - 1 && (
                                <div
                                    className="right-next"
                                    onClick={this.rapidNextClick}
                                >
                                    <img
                                        className="arrowLeftRight"
                                        src={
                                            "/cn/img/withdrawlesson/icon-right.svg"
                                        }
                                        alt="right"
                                    />
                                </div>
                            )}
                            {
                                <div className="deposit-comment-title">
                                    {
                                        withdrawCryptoComment[
                                            this.state.rapidIndex
                                        ].title
                                    }
                                </div>
                            }
                            {/* {<div className="deposit-comment-content">{withdrawCryptoComment[this.state.rapidIndex].content}</div>} */}
                            {/* <button
                className="deposit-comment-button"
                onClick={() => {
                  this.handleClick();
                  console.log("clicked");
                }}
              >
                确认
              </button> */}
                        </TabPane>
                        <TabPane tab="如何添加钱包地址?" key="2">
                            <Carousel
                                key={1}
                                ref="GeneralSlider"
                                className="custom-Carousel"
                                afterChange={(current) => {
                                    this.generalOnChange(current);
                                }}
                            >
                                {addressCryptoLessons.map((item, index) => (
                                    <div
                                        key={item.id}
                                        className={`crypto-lesson-wrap ${item.id}`}
                                    >
                                        <div className="crypto-lesson-body">
                                            {item.content()}
                                        </div>
                                    </div>
                                ))}
                            </Carousel>
                            {this.state.generalIndex > 0 && (
                                <div
                                    className="left-next"
                                    onClick={this.generalPrevClick}
                                >
                                    <img
                                        className="arrowLeftRight"
                                        src={
                                            "/cn/img/withdrawlesson/icon-left.svg"
                                        }
                                        alt="left"
                                    />
                                </div>
                            )}
                            {this.state.generalIndex !=
                                addressCryptoLessons.length - 1 && (
                                <div
                                    className="right-next"
                                    onClick={this.generalNextClick}
                                >
                                    <img
                                        className="arrowLeftRight"
                                        src={
                                            "/cn/img/withdrawlesson/icon-right.svg"
                                        }
                                        alt="right"
                                    />
                                </div>
                            )}
                            {
                                <div className="deposit-comment-title">
                                    {
                                        addressCryptoComment[
                                            this.state.generalIndex
                                        ].title
                                    }
                                </div>
                            }
                            {/* {<div className="deposit-comment-content">{addressCryptoComment[this.state.generalIndex].content}</div>} */}
                            {/* <button className="deposit-comment-button" onClick={()=>{this.handleClick();console.log("clicked");}}>确认</button> */}
                        </TabPane>
                    </Tabs>
                </div>

                <div></div>
            </React.Fragment>
        );
    }
}
export default WithdrawLesson;
